import React from "react"
import ErrorComponent from "../error-component/ErrorComponent"
import { logError } from "./MonitoringClient"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: undefined }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error }
  }

  componentDidCatch(error, errorInfo) {
    console.error({ error: error })
    console.error({ errorInfo: errorInfo })
    logError(typeof error === "string" || error instanceof String ? error : "Empty error message", errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return <ErrorComponent error={this.state.error}></ErrorComponent>
    }

    return this.props.children
  }
}

export default ErrorBoundary
